export default __webpack_public_path__ + "static/media/email-icon.3cbc1998.svg";